<template>
  <div>
    <el-dialog :visible.sync="visible" width="30%">
      <div slot="title" class="title-container">
        <span>{{product.name}}</span>
      </div>
      <el-alert
        show-icon
        :closable="false"
        title="Price B, C, D and E are all automatically calculated based on A price."
        type="info">
      </el-alert>
      <br>
      <el-row>
        <el-col :span="4"></el-col>
        <el-col :span="15">
          <el-form label-width="120px">
              <el-form-item label="A price">
                <el-input
                  type="number"
                  v-model="product.classAPrice"
                  :step="0.01"
                  :min="0"
                  size="mini"
                ></el-input>
              </el-form-item>
              <el-form-item label="VIP price">
                <el-input
                  type="number"
                  v-model="product.standardPrice"
                  :step="0.01"
                  :min="0"
                  size="mini"
                ></el-input>
              </el-form-item>
              <el-divider></el-divider>
              <el-form-item label="Special or not">
                <el-select v-model="product.is_special" size="mini">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              </el-form-item>
              <el-form-item label="Special price">
                <el-input
                  type="number"
                  v-model="product.specialPrice"
                  :step="0.01"
                  :min="0"
                  size="mini"
                ></el-input>
                <!-- :disabled="product.is_special===0?true:false" -->
              </el-form-item>
              <el-divider></el-divider>
              <el-form-item label="Tempe Price">
                <el-input
                  type="number"
                  v-model="product.ref_pur"
                  :step="0.01"
                  :min="0"
                  size="mini"
                ></el-input>
              </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible">Cancel</el-button>
        <el-button size="mini" type="primary" @click="handleSubmit">Submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { changeProductPrice } from '../api'
export default {
  name: 'DialogStdSABEdit',
  computed: {
    visible: {
      get () {
        return this.dialogVisible
      },
      set (val) {
        this.$emit('closed')
      }
    }
  },
  data () {
    return {
      prices: [],
      tempSpPrice: 0,
      lineSelected: true,
      options: [
        {
          value: 1,
          label: 'Yes'
        },
        {
          value: 0,
          label: 'No'
        }]
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    dialogFormVisible () {
      this.$emit('closed')
    },
    async handleSubmit () {
      if (this.product.is_special && Number.parseFloat(this.product.specialPrice) === 0) {
        this.$message({
          message: 'When "Special or not" is YES, "Monthly Special" price CANNOT be 0',
          type: 'error'
        })
        return
      }
      if (!this.product.is_special && Number.parseFloat(this.product.specialPrice) > 0) {
        this.$message({
          message: 'When the "Monthly Special" price is set, "Special or not" MUST be YES',
          type: 'warning'
        })
        return
      }
      let realSpPrice
      if (!this.product.is_special) {
        realSpPrice = 0
      } else if (this.product.is_special && Number.parseFloat(this.product.specialPrice) > 0) {
        realSpPrice = Number.parseFloat(this.product.specialPrice)
      }
      const params = {
        standardPrice: Number.parseFloat(this.product.standardPrice),
        specialPrice: realSpPrice,
        classAPrice: Number.parseFloat(this.product.classAPrice),
        classBPrice: Number.parseFloat(this.product.classBPrice),
        ref_pur: Number.parseFloat(this.product.ref_pur),
        is_special: this.product.is_special,
        is_clearance: this.product.is_clearance,
        is_customer_show: this.product.is_customer_show
      }
      await changeProductPrice(this.product.id, params)
      this.$message({
        message: 'Operation successful',
        type: 'success'
      })
      // this.reload(this.id)
      this.$emit('success')
    }
  },
  watch: {
    StdSABPrices: function (val) {
      this.prices = val
    },
    'product.is_special': {
      handler (newVal, oldVal) {
        if (newVal === 0 && oldVal !== undefined && this.product.specialPrice !== 0) {
          this.product.specialPrice = 0
          this.$message({
            message: 'The Special Price will be automatically set to ZERO when special or not is set to NO',
            type: 'warning'
          })
        }
      },
      immediate: true,
      deep: false
    }
  }
}
</script>

<style lang="scss" scoped>
.title-container {
  color: #000;
  line-height: 48px;
  padding: 0 60px 0 20px;
  font-size: 13px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}
</style>
